var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404-wrap"},[_c('p',[_vm._v("The page you have requested does not exist on our website.")]),_c('br'),_c('p',[_vm._v("Go to our "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home Page")]),_vm._v(" instead.")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }